
import { deviceType, controlType } from "../constant";

export const shouldShowEngineHours = (car, carProductData) => {
  const isFT2WithoutControl =
    car?.DevType === deviceType.FT2 && (car?.CarControlType === "" || car?.CarControlType === null || car?.CarControlType === controlType.None);

  const isVDUWithFusionNoSerial =
    ((car?.DevType === deviceType.VDU3 ||
      car?.DevType === deviceType.VDU4) &&
      ((car?.CarControlType === controlType.Fusion && !carProductData?.CarSerialNumber) || car?.CarControlType === controlType.GCCM ||
        car?.CarControlType === "" || car?.CarControlType === null || car?.CarControlType === controlType.None));

  return (
    isFT2WithoutControl ||
    isVDUWithFusionNoSerial
  );
}